import { useCallback, useContext, useEffect, useState } from 'react';

import { GetCreationByIdQuery } from '../../../graphql/generated/graphql';
import { context as DependencyContext } from '../../context/dependency';

const useGetCreationQuery = (creationId: string) => {
  const dependency = useContext(DependencyContext);

  const [creation, setCreation] = useState<NonNullable<GetCreationByIdQuery['creation']>>();
  const [loading, setLoading] = useState(0);
  const fetchData = useCallback(async () => {
    setLoading((loading) => ++loading);
    try {
      const creation = await dependency.creationWebApi.getById(creationId);
      setCreation(creation);
    } catch (err) {
      dependency.errorPresenter.showAsNonFatal(err);
    } finally {
      setLoading((loading) => --loading);
    }
  }, [dependency.creationWebApi, dependency.errorPresenter, creationId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    creation: creation,
    loading: loading > 0,
    reload: fetchData,
  };
};

export default useGetCreationQuery;
